// extracted by mini-css-extract-plugin
export default {"svg":"LoadingIcon_svg__DV0P1"};